import React from "react";
import { Navbar, Container } from "react-bootstrap";
import DefaultNavbarLinks from "./DefaultNavbarLinks";

export interface NavbarProps {
    navbar: boolean
    handleMiniClick: () => void
}

const DefaultNavbar: React.FC<NavbarProps> = ({ navbar, handleMiniClick }) => {

    // function for responsive that hides/shows the sidebar
    function mobileSidebarToggle(e) {
        document.documentElement.classList.toggle("nav-open");
    };

    return (
        <Navbar className={navbar ? "navbar-default navbar-fixed" : "navbar-default"}>
            <Container fluid>
                <div className="navbar-minimize">
                    <button id="minimizeSidebar" className="btn btn-default btn-fill btn-round btn-icon" onClick={handleMiniClick} >
                        <i className="fa fa-ellipsis-v visible-on-sidebar-regular" />
                        <i className="fa fa-navicon visible-on-sidebar-mini" />
                    </button>
                </div>
                <div className="navbar-header">
                    <Navbar.Toggle onClick={mobileSidebarToggle} />
                </div>
                {/* Here we import the links that appear in navbar */}
                {window.innerWidth > 992 ? (
                    <Navbar.Collapse>
                        <DefaultNavbarLinks />
                    </Navbar.Collapse>
                ) : null}
            </Container>
        </Navbar>
    );
}
export default DefaultNavbar;